import dashboard from './general-routes';
import shopFront from './shop-routes';
import authRoutes from './auth-routes';

const recursiveFlatMap = (routes) =>
  routes.flatMap((route) => [route, ...recursiveFlatMap(route.children ?? [])]);

export default [
  ...recursiveFlatMap(dashboard),
  ...recursiveFlatMap(shopFront),
  ...recursiveFlatMap(authRoutes),
];
